import { useEffect } from "react";

import { Link } from "@remix-run/react";
import { MetaFunction } from "@vercel/remix";

import data from "~/data";
import { useTrackLinks } from "~/utils/analytics";

export const meta: MetaFunction = () => {
    return [{ title: "Home | Our Guidant" }, { name: "description", content: "Online Funeral Planning Made Simple" }];
};

export default function Index() {
    useTrackLinks("#immediate-need", "Flow Selection", {
        label: "Immediate Need",
    });
    useTrackLinks("#plan-for-the-future", "Flow Selection", {
        label: "Plan for the future",
    });

    useEffect(() => {
        window.dataLayer.push({ event: "gtm-test" });
    });

    return (
        <section className="flex justify-center items-start md:items-center bg-black/70 bg-blend-darken bg-cover bg-no-repeat grow md:min-h-[1000px] relative">
            <video
                src={data.video.src}
                autoPlay
                loop
                muted
                playsInline
                className="absolute inset-0 w-[115%] h-[110%] object-cover pointer-events-none -z-10"
                poster={data.video.poster}
            />
            <div className="z-10 flex flex-col gap-12 md:gap-12 px-page py-10 md:py-20 max-w-[1200px] mx-auto">
                <div className="flex flex-col gap-4">
                    <h1 className="text-center text-white font-title text-3xl md:text-6xl text-balance !leading-normal">
                        {data.landing.title}
                    </h1>
                    <p className="text-center text-white font-bold md:text-xl uppercase">{data.landing.description}</p>
                </div>
                <section className={data.landing.linksClassName}>
                    {data.landing.buttons.map((button, index) => (
                        <Link
                            key={index}
                            id={button.id}
                            className="relative flex items-center gap-6 bg-white p-6 rounded-lg shadow-lg min-h-[128px] md:min-h-[auto] group overflow-hidden"
                            to={button.link}
                            prefetch="render"
                        >
                            <div className="absolute top-0 left-0 h-1.5 w-0 group-hover:w-full bg-primary transition-all duration-300" />
                            <img
                                src={button.icon}
                                alt={button.text}
                                className="w-10 h-10 md:w-16 md:h-16"
                            />
                            <section className="flex flex-col justify-center gap-2 h-full">
                                <h2 className="font-bold md:text-xl">{button.text}</h2>
                                <p>{button.description}</p>
                            </section>
                        </Link>
                    ))}
                </section>
            </div>
        </section>
    );
}
